type ApiErrorBodyLike = {
  detail?: unknown;
  non_field_errors?: unknown;
};

type ApiErrorLike = {
  error?: ApiErrorBodyLike | null;
  message?: unknown;
};

export function getApiErrorDetail(error: unknown): string | null {
  if (typeof error === 'string') {
    return error.trim() || null;
  }

  const apiError = error as ApiErrorLike | null | undefined;
  const detail = apiError?.error?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  const nonFieldErrors = apiError?.error?.non_field_errors;
  if (Array.isArray(nonFieldErrors)) {
    const firstMessage = nonFieldErrors.find(
      (value): value is string => typeof value === 'string' && Boolean(value.trim()),
    );
    if (firstMessage) {
      return firstMessage;
    }
  }

  return typeof apiError?.message === 'string' && apiError.message.trim() ? apiError.message : null;
}
